/**
 * Cron jobs 
 * Check jobs collection every 5 seconds
 * this is alternative for background sync because service worker background sync not supported in ios
 */

import Helper from '@/helpers/helper'
import axios from 'axios'
import { 
    getJobs, 
    deleteJob, 
    getCollection, 
    addUpdateCollection, 
    updateCollection, 
    deleteCollection,
    overridecollection
} from '@/helpers/localbase'

export const crontabmixins = {
    data() {
        return {
            processing: false,
            failed    : []
        }
    },
    computed : {
        isonline() {
            return this.$store.state.isonline;
        }
    },
    methods : {
        /**
         * Initialize Cron
         * Run everery 5 secs
         * Documentary : https://www.npmjs.com/package/vue-crontab
         */
        initCron() {
            this.$crontab.addJob({
                name    : 'cronjobmonitor',
                interval: {
                    seconds: '/5',
                },
                sync     : 1,
                condition: () => this.processing || !this.isonline ? false: true,
                job      : this.apiCalls
            });
        },
        /**
         * Api request's 
         * Jobs are from indexed db jobs collection
         */
        async apiCalls() {
            this.processing = true;
            
            const jobs = await getJobs();

            if(jobs && Array.isArray(jobs)) {
                for (let index = 0; index < jobs.length; index++) {
                    const doc     = jobs[index];
                    const job     = doc.data;
                    const params  = job.params ? job.params : {};
                    const options = {
                        db    : {
                            getCollection, 
                            addUpdateCollection, 
                            updateCollection, 
                            deleteCollection,
                            overridecollection
                        },
                        job   : job,
                        helper: Helper,
                        router: this.$router,
                        route : this.$route,
                        store : this.$store
                    }
                    
                    /**
                     * Check if this job failed mutiple times
                     * if failed more than 5 times 
                     * remove from job list
                     * then  don't continue to process
                     */

                    const failed = this.failed.filter(f => f == doc.key);

                    if(failed.length > 4) {
                        // remove from job list
                        deleteJob(doc.key);

                        // remove from failed list
                        this.failed = this.failed.filter(f => f != doc.key);

                        continue;
                    }
                    
                    /**
                     * Check what method is going the use on the request
                     * 
                     */
                    switch (job.method) {

                        case 'GET':
                                await axios.get(job.url, {params : params})
                                .then((res) => {
                                    deleteJob(doc.key);
                                    
                                    const callback = job.callback ? JSON.parse(job.callback, Helper.deserialize) : null;
                                    
                                    if(callback && typeof callback == 'function') {
                                        callback(res.data, options);
                                    }
                                }).catch((err) => {
                                    console.log('error job get api request', err);
                                    this.failed = [...this.failed, doc.key]
                                });
                            break;
                        
                        case 'POST':
                                await axios.post(job.url, params).then((res) => {
                                    deleteJob(doc.key);
                                    
                                    const callback = job.callback ? JSON.parse(job.callback, Helper.deserialize) : null;
                                    
                                    if(callback && typeof callback == 'function') {
                                        callback(res.data, options);
                                    }
                                }).catch((err) => {
                                    this.failed = [...this.failed, doc.key]
                                    console.log('error job post api request', err)
                                });
                            break;
                        
                        case 'PUT':
                                await axios.put(job.url, params).then((res) => {
                                    deleteJob(doc.key);
                                    
                                    const callback = job.callback ? JSON.parse(job.callback, Helper.deserialize) : null;
                                    
                                    if(callback && typeof callback == 'function') {
                                        callback(res.data, options);
                                    }
                                }).catch(() => {
                                    console.log('error job put api request')
                                    this.failed = [...this.failed, doc.key]
                                });
                            break;

                        case 'DELETE':
                                await axios.delete(job.url, params).then(() => {
                                    deleteJob(doc.key);
                                }).catch(() => {
                                    console.log('error job delete api request')
                                    this.failed = [...this.failed, doc.key]
                                });
                            break;
                    
                        default:
                            break;
                    }


                }
            }

            this.processing = false;
        }
    }
}